import {
  ACTIVE_USER,
} from '../constants/User';

const initState = {
  activeUser: undefined,
}

const user = (state = initState, action) => {

  switch (action.type) {

    case ACTIVE_USER:
      return {
        ...state,
        activeUser: action.payload,
      };

    default:
      return state;
  }
}

export default user